import { X, Upload, Camera } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UploadChoiceModalProps {
  onClose: () => void;
  onChooseUpload: () => void;
  onChooseScan: () => void;
}

export function UploadChoiceModal({
  onClose,
  onChooseUpload,
  onChooseScan,
}: UploadChoiceModalProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-[#16151D] rounded-xl shadow-2xl max-w-md w-full border dark:border-white/8 overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-xl font-semibold mb-1">{t('documents.addChoiceModal.title')}</h2>
              <p className="text-sm opacity-90">
                {t('documents.addChoiceModal.subtitle')}
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="text-white/80 hover:text-white p-1"
              aria-label="Close"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="p-6 flex flex-col sm:flex-row gap-4">
          <button
            type="button"
            onClick={onChooseUpload}
            className="flex-1 flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-gray-200 dark:border-white/10 hover:border-blue-500 dark:hover:border-blue-500/50 hover:bg-blue-50/50 dark:hover:bg-blue-900/10 transition-colors"
          >
            <div className="w-14 h-14 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <Upload className="w-7 h-7 text-blue-600 dark:text-blue-400" />
            </div>
            <div className="text-center">
              <div className="font-medium dark:text-white">{t('documents.addChoiceModal.uploadFile')}</div>
              <div className="text-sm text-gray-500 dark:text-white/60 mt-0.5">
                {t('documents.addChoiceModal.uploadFileDesc')}
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={onChooseScan}
            className="flex-1 flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-gray-200 dark:border-white/10 hover:border-purple-500 dark:hover:border-purple-500/50 hover:bg-purple-50/50 dark:hover:bg-purple-900/10 transition-colors"
          >
            <div className="w-14 h-14 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center">
              <Camera className="w-7 h-7 text-purple-600 dark:text-purple-400" />
            </div>
            <div className="text-center">
              <div className="font-medium dark:text-white">
                {t('documents.addChoiceModal.scanTakePhoto')}
              </div>
              <div className="text-sm text-gray-500 dark:text-white/60 mt-0.5">
                {t('documents.addChoiceModal.scanTakePhotoDesc')}
              </div>
            </div>
          </button>
        </div>

        <div className="px-6 pb-6">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2.5 text-sm text-gray-600 dark:text-white/70 hover:text-gray-900 dark:hover:text-white"
          >
            {t('documents.addChoiceModal.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}
